import {Component, OnInit} from '@angular/core';
import {Service} from '../service';
import {Router} from '@angular/router';

const LOGIN_TOKEN_KEY = 'my_login_token';

@Component({
  // tslint:disable-next-line
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css']
})
export class ClaimComponent implements OnInit {
  array: any[];
  claimed: any[] = [];
  not_claimed: any[] = [];
  from = 0;
  to = 0;
  bus = 0;
  plane = 0;
  taxi = 0;
  fuel = 0;
  bed = 0;
  env = 0;
  da = 0;
  phone = 0;
  misc = 0.0;
  tclaim = 0;
  tapprove = 0;
  empcode: any;
  state: any;
  mobile: any;
  name: string;
  token = '';
  level: string;
  datefrom = '';
  dateto = '';
  HQ: any;
  icon: string;
  loading = false;
  available = false;
  logourl: string;
  area: string;
  zone: string;
  visible = false;
  fkorg: string;

  constructor(private service: Service, private router: Router) {
  }

  getdata() {
    this.loading = true;
    this.service.getTable(this.datefrom, this.dateto, this.token).subscribe(value => {
      this.array = value;
      this.sortAndCalc();
      if (this.array.length === 0) {
        this.available = true;
      }
      this.loading = false;
    });
  }

  round(number, precision) {
    const factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  sortAndCalc() {
    // sorting
    for (let i = 0; i < this.array.length; i++) {
      if (this.array[i].is_no_claim === 0) {
        this.claimed.push(this.array[i]);
      } else {
        this.not_claimed.push(this.array[i]);
      }
    }
    console.log(this.claimed);
    console.log(this.not_claimed);
    // Calculations
    for (let i = 0; i < this.claimed.length; i++) {
      if (this.claimed[i].cdata.travel_from != null) {
        this.from += parseInt(this.claimed[i].cdata.travel_from);
      }
      if (this.claimed[i].cdata.travel_to != null) {
        this.to += parseInt(this.claimed[i].cdata.travel_to);
      }
      if (this.claimed[i].fuel_claim != null) {
        this.fuel += this.claimed[i].fuel_claim;
      }
      this.bus += this.claimed[i].travel;
      this.plane += parseInt(this.claimed[i].cdata.air);
      this.taxi += parseInt(this.claimed[i].cdata.taxi);
      this.bed += this.claimed[i].hotel;
      this.env += this.claimed[i].stationary;
      this.da += this.claimed[i].da;
      this.phone += this.claimed[i].phone;
      this.misc += parseInt(this.claimed[i].cdata.misc);
      this.tclaim += this.claimed[i].total_claimed;
      this.tapprove += this.claimed[i].total_approved;
    }
    // Round-off
    this.fuel = this.round(this.fuel, 2);
    this.tclaim = this.round(this.tclaim, 2);
    this.tapprove = this.round(this.tapprove, 2);
  }

  printReport() {
    const printContents = document.getElementById('print-section').innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    document.location.reload();
  }

  ngOnInit(): void {
    this.state = localStorage.getItem('state');
    this.name = localStorage.getItem('name');
    this.token = localStorage.getItem(LOGIN_TOKEN_KEY);
    this.datefrom = localStorage.getItem('start_date');
    this.dateto = localStorage.getItem('end_date')
    this.level = localStorage.getItem('level');
    this.HQ = localStorage.getItem('city');
    this.mobile = localStorage.getItem('mobile');
    this.logourl = localStorage.getItem('logo');
    this.area = localStorage.getItem('area');
    this.zone = localStorage.getItem('zone');
    this.empcode = localStorage.getItem('empid');
    this.fkorg = localStorage.getItem('fkorg');
    if (localStorage.getItem('fkorg') === '2') {
      this.visible = true;
    }
    console.log(this.visible);
    this.getdata();
  }
}



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/appcomponents/claim.ts